import { makeStyles } from 'tss-react/mui';
import { brandColors } from '@/styles/theme/values/brandColors';

const useStyles = makeStyles({
  name: 'SunrunShopProductPage',
})(({ type, spacing }) => ({
  buyNowButton: {
    width: '100%',
  },
  optionsContainer: {
    marginTop: spacing(0),

    '& > li': { padding: `calc(${spacing(0)} / 2) 0` },
  },
  cardContent: {
    ...type['18_regular'],
  },
  disabledCardContent: {
    color: brandColors.tintsNeutral20,
  },
}));

export default useStyles;
